export default __webpack_public_path__ + "static/media/home-right-side.46301d0a.svg";